/**
 * A function which returns the value passed in.
 * @param value The value to return.
 * @returns The value.
 */
export function identity<T>(value: T): T {
  return value;
}
